import React, { useEffect, useState } from "react";
import {
  Card,
  Grid,
  Text,
  Button,
  Badge,
  Divider,
  Box,
  Center,
  Loader,
  createStyles,
} from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { useMedplum } from "@medplum/react";
import { getPatientName } from "../EligibiltyService";

interface PatientDetails {
  relationship: string;
  name: string;
  address: string[];
  cityStateZip: string;
  gender: string;
  dateOfBirth: string;
  planNumber: string;
  serviceDate: string;
  eligibilityBegin: string;
  memberId: string;
  subscriberName: string;
  eligibilityStatus: string;
  groupNumber: string;
  eligibilityCoverageDate: string;
  planCoverageDate: string;
  payerType: string;
  Organization: string;
}

interface TransactionDetails {
  transactionId: string;
  customerId: string;
}

// interface Props {
//   patientDetails: PatientDetails;
//   coverageReesponse: any;
// }

const useStyles = createStyles(() => ({
  loader: {
    marginTop: "40px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

export const PatientDetails = ({ patient, coverageReesponse,otherDetails, preAuth,planDetails }: { patient?: any; coverageReesponse?: any; otherDetails?:any; preAuth?:any; planDetails?:boolean }) => {
  const renderRow = (fields: { label: string; value: string }[]) => (
    <Box
      mb={"12px"}
      sx={{ border: "1px solid #eaeaea", padding: "24px", borderRadius: "5px" }}
    >
      <Grid align="center" style={{ padding: "10px 0" }}>
        {fields?.map((field, index) => (
          <Grid.Col             xs={12}
          sm={6}
          md={4}
          lg={3}
span={3} key={index} style={{ position: "relative" }}>
            <Text color="#474E5B" weight={500} fs={"14px"}>
              {field?.label}
            </Text>
            <Text size={"sm"} weight={600} fs={"14px"} tt={'capitalize'}>
              {field?.value}
            </Text>
            {index < fields?.length - 1 && (
              <Divider
                orientation="vertical"
                style={{
                  position: "absolute",
                  right: 0,
                  top: "10%",
                  bottom: "10%",
                  marginRight: "20px",
                }}
              />
            )}
          </Grid.Col>
        ))}
      </Grid>
    </Box>
  );

  return (
    <>{patient &&<>
     <Text size="xl" weight={600} mb={'12px'}>
        Patient Details
      </Text>
      <Box>
        {/* Row 1 */}
        {renderRow([
          { label: "Name", value: getPatientName(patient?.name)??'--' },
          { label: "Date of Birth", value: patient?.birthDate??"--" },
          { label: "Address", value: patient?.address?.[0]?.line?.join(', ') ?? '--' },
          { label: "City-State-Zip", value: `${patient?.address?.[0]?.city??"--"} - ${patient?.address?.[0]?.state??"--"} - ${patient?.address?.[0]?.postalCode??""}` },
        ])}
        
        {!planDetails &&<> 
          <Text size="xl" weight={600} mb="12px" mt={24}>
          Plan Details
        </Text>
        {/* {renderRow([
          { label: "Plan Name", value: coverageReesponse?.[0]?.class?.[0]?.name??'--' },
          { label: "Plan Number", value: coverageReesponse?.[0]?.class?.[0]?.value??'--' },
          { label: "Policy Type", value: coverageReesponse?.[0]?.class?.[0]?.type?.text??'--' },
        ])} */}
        {renderRow([
          { label: "Certificate Start", value: preAuth?.preAuthPeriod?.start},
          { label: "Certificate Expiration", value: preAuth?.preAuthPeriod?.end},
        ])}
        </>}
         
        {/* Other rows can be added here */}
      </Box></>}
      
     
      {otherDetails &&  <Box>
       
       <Text size="xl" weight={600} mb="12px" mt={24}>
        Other Details
      </Text>
      {renderRow([
           { label: "Patient Account Number", value: otherDetails?.patientAccountNumber ?? '--' },
           { label: "Total Charges", value: otherDetails?.totalCharges ?? '--' },
           { label: "Billing Provider ID", value: otherDetails?.billingProviderId ?? '--' },
           { label: "Billing Provider API", value: otherDetails?.billingProviderApi ?? '--' },
        ])}
          {renderRow([
        
          { label: "Payer Claim Number", value: otherDetails?.payerClaimNumber ?? '--' },
          { label: "Payer ID", value: otherDetails?.payerId ?? '--' },
          { label: "Payer Seq Number", value: otherDetails?.payerSeqNumber ?? '--' },
          { label: "Availity Batch ID", value: otherDetails?.availityBatchId ?? '--' },
        ])}
         {renderRow([
        
         { label: "Claim Sequence", value: otherDetails?.claimSequence ?? '--' },
         { label: "Message Type", value: otherDetails?.messageType ?? '--' },
         { label: "Message Code", value: otherDetails?.messageCode ?? '--' },
         { label: "Message Loop", value: otherDetails?.messageLoop ?? '--' },
        ])}
       
      {renderRow([
        
         
        
         
          { label: "Message Segment", value: otherDetails?.messageSegment ?? '--' },
          { label: "Message Element", value: otherDetails?.messageElement ?? '--' },
      ])}
    
    </Box>}
     
    </>
  );
};

export const TransactionDetails = ({ claimRes }: { claimRes: any }) => {
  return (
    <Box mb={24} mt={24}>
      <TransactionCard
        details={{
          transactionId: claimRes?.extension?.find((ext: any) => ext?.url === "txId")?.valueString ?? '--',
          customerId: claimRes?.extension?.find((ext: any) => ext?.url === "custId")?.valueString ?? '--',
        }}
      />
      <Box
        sx={{
            paddingTop:"16px",
          width: "100%",
          height: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            padding: "16px",
            borderRadius: "5px",
            backgroundColor: "#FAFAFA",
            border: "1px solid #EDEDED",
          }}
        >
          <Text size="lg" weight={500}>
            Certificate Information
          </Text>
        </Box>
        <Box
          sx={{
            display: "flex",
            padding: "12px",
            borderRadius: "5px",
            border: "1px solid #EDEDED",
            width: "100%",
            height: "auto",
            flexDirection: "column",
          }}
        >
          <Box sx={{ width: "100%", display: "flex", flexDirection: "row" }}>
            <Box sx={{ width: "50%", display: "flex", flexDirection: "row", gap: "12px" }}>
              <Text weight={500} color="#474E5B" size="14px">Reference Number</Text>
              <Text> :</Text>
              <Text color="#262930" weight={600} size="14px">
                {claimRes?.preAuthRef ?? "--"}
              </Text>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end", width: "50%" }}>
              <Badge color="orange" radius={"sm"} size="md">
                {claimRes?.outcome}
              </Badge>
            </Box>
          </Box>

          <Divider sx={{ margin: "16px 0px" }} />
          <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "12px" }}>
            <Text weight={500} color="#474E5B" size="14px">Review reason</Text>
            <Text color="#262930" weight={600} size="14px">{claimRes?.disposition}</Text>
          </Box>
          <Divider sx={{ margin: "16px 0px" }} />
          <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "12px" }}>
            <Text weight={500} color="#474E5B" size="14px">Message</Text>
            <Text color="#262930" weight={600} size="14px">
              Your request has been received. Check status via the dashboard. Standard turn-around for authorization reviews apply. Contact the health plan with questions.
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const TransactionCard: React.FC<{ details: TransactionDetails }> = ({ details }) => {
  return (
    <Card
      padding="lg"
      radius="md"
      style={{
        border: "1px solid #BEDEF8",
        backgroundColor: "#F0F8FF",
        width: "100%",
      }}
    >
      <Grid align="center">
        {/* Transaction ID */}
        {Object.entries(details).map(([key, value]) => (
          <Grid.Col span={4} key={key}>
            <Box sx={{ display: "flex", flexDirection: "row", gap: "3px" }}>
              <Text color="#474E5B" weight={500} fs={"14px"} tt={"capitalize"} inline>
                {key.replace("Id", " ID")}
              </Text>
              <Text inline weight={600} fs={"14px"}>
                : {value}
              </Text>
            </Box>
          </Grid.Col>
        ))}
      </Grid>
    </Card>
  );
};